// src/components/common/vibe/ConfettiEffect.js
import React, { useEffect, useRef } from 'react';

const ConfettiEffect = ({ trigger = false, duration = 3000 }) => {
    const canvasRef = useRef(null);
    const confettiPieces = useRef([]);
    const animationFrameRef = useRef(null);

    console.log('🎊 ConfettiEffect - Component rendered with trigger:', trigger);

    useEffect(() => {
        console.log('🎊 ConfettiEffect - useEffect triggered, trigger value:', trigger);
        if (!trigger) {
            console.log('❌ ConfettiEffect - trigger is false, skipping animation');
            return;
        }

        console.log('✅ ConfettiEffect - Starting confetti animation!');

        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        // Confetti colors
        const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2'];

        class Confetti {
            constructor() {
                this.x = Math.random() * canvas.width;
                this.y = Math.random() * canvas.height - canvas.height;
                this.size = Math.random() * 10 + 5;
                this.speedY = Math.random() * 3 + 2;
                this.speedX = Math.random() * 2 - 1;
                this.color = colors[Math.floor(Math.random() * colors.length)];
                this.rotation = Math.random() * 360;
                this.rotationSpeed = Math.random() * 10 - 5;
            }

            update() {
                this.y += this.speedY;
                this.x += this.speedX;
                this.rotation += this.rotationSpeed;

                // Gravity effect
                this.speedY += 0.1;

                // Remove confetti that falls off screen
                if (this.y > canvas.height) {
                    return false;
                }
                return true;
            }

            draw() {
                ctx.save();
                ctx.translate(this.x, this.y);
                ctx.rotate((this.rotation * Math.PI) / 180);
                ctx.fillStyle = this.color;

                // Draw rectangle confetti
                ctx.fillRect(-this.size / 2, -this.size / 2, this.size, this.size / 2);

                ctx.restore();
            }
        }

        // Create confetti pieces
        confettiPieces.current = [];
        for (let i = 0; i < 150; i++) {
            confettiPieces.current.push(new Confetti());
        }

        // Animation loop
        const animate = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            confettiPieces.current = confettiPieces.current.filter((confetti) => {
                confetti.update();
                confetti.draw();
                return confetti.y < canvas.height;
            });

            if (confettiPieces.current.length > 0) {
                animationFrameRef.current = requestAnimationFrame(animate);
            }
        };

        animate();

        // Auto stop after duration
        const timeout = setTimeout(() => {
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
            }
            confettiPieces.current = [];
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        }, duration);

        // Cleanup
        return () => {
            clearTimeout(timeout);
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
            }
        };
    }, [trigger, duration]);

    if (!trigger) return null;

    return (
        <canvas
            ref={canvasRef}
            className="fixed inset-0 pointer-events-none z-50"
            style={{ zIndex: 9999 }}
        />
    );
};

export default ConfettiEffect;
